import {
  useCurrentWorkspace,
  useModifyWorkspace,
  useWorkspaceKeysStore,
} from '@easy-expense/data-firestore-client';
import { getTranslation } from '@easy-expense/intl-client';
import { theme } from '@easy-expense/ui-theme';
import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';
import { Checkbox } from '@mui/material';

export const WorkspaceShowTransactionNumber: React.FC = () => {
  const workspace = useCurrentWorkspace();

  const currentWorkspacePath = useWorkspaceKeysStore((s) => s.currentWorkspacePath());
  const [updateWorkspace] = useModifyWorkspace(currentWorkspacePath, 'update');

  function onChange(showTransactionID: boolean) {
    if (!workspace?.settings) {
      return;
    }
    updateWorkspace({
      settings: {
        ...workspace.settings,
        showTransactionID,
      },
    });
  }
  return (
    <Layout.Row
      align
      style={{
        borderTop: `1px solid ${theme.colors.inputBorder}`,
      }}
      px
      py
    >
      <Layout.Column
        style={{
          maxWidth: 350,
        }}
      >
        <Layout.Row align>
          <OpenSans.Primary size={16} weight="bold-700">
            {getTranslation('Show Transaction Number')}
          </OpenSans.Primary>
        </Layout.Row>
        <Layout.Row align>
          <OpenSans.Secondary size={16}>
            {getTranslation('Add transaction/receipt/invoice number field')}
          </OpenSans.Secondary>
        </Layout.Row>
      </Layout.Column>
      <Spacer.Horizontal size={24} />
      <Layout.Column>
        <Checkbox
          style={{ padding: 0 }}
          checked={workspace?.settings.showTransactionID}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const show = event.target.checked;
            onChange(show);
          }}
        />
      </Layout.Column>
    </Layout.Row>
  );
};
